// extracted by mini-css-extract-plugin
export default {"filterRow":"SupplyChain_filterRow__QxoQn","filterItem":"SupplyChain_filterItem__8xULJ"};